import { render, staticRenderFns } from "./CloseNotificationSetting.vue?vue&type=template&id=37953a72&scoped=true"
import script from "./CloseNotificationSetting.vue?vue&type=script&lang=js"
export * from "./CloseNotificationSetting.vue?vue&type=script&lang=js"
import style0 from "./CloseNotificationSetting.vue?vue&type=style&index=0&id=37953a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37953a72",
  null
  
)

export default component.exports